$(function () {
    // navigation open close
    $('.nav_btn').on('click', function () {
        $('body').toggleClass('nav_show');
        return false;
    });

    // navigation menu open close
    $('.navigation .menu > li > .accordion_btn').on('click', function () {
        $(this).parent().toggleClass('active');
        return false;
    });

    let headerAndFooterHeight = 0;
    headerAndFooterHeight += $('#footer').height()
    if (window.matchMedia('(max-width:767px)').matches) {
        headerAndFooterHeight += $('#header').height()
    } else {
        headerAndFooterHeight += $('.header-nav').height()
    }
    $('#main').css('min-height',`calc(110vh - ${headerAndFooterHeight}px)`);


});